import { PHRASE_DATA } from '../App'

const versNum = 8

export async function indexedDBinit(loading, setLoading, setProgBarWidth, setClipId, setPercent, setErrorMsg) {
  //  Handle indexedDB
  const indexedDB = window.indexedDB || window.webkitIndexedDB //  || window.msIndexedDB || window.mozIndexedDB ||window.shimIndexedDB

  // Open (or create) the database
  const request = indexedDB.open('learnChinese', versNum)

  request.onerror = function (event) {
    setErrorMsg('An error occurred with IndexedDB')
    console.error('An error occurred with IndexedDB')
    console.error(event)
  }

  // Create the schema on create and version upgrade
  request.onupgradeneeded = async function () {
    const db = request.result
    //  store is like a table or collection
    const dataStore = db.createObjectStore('phraseData', {
      keyPath: 'phraseId',
    })
    //  Create indexes to query
    dataStore.createIndex('chinese', ['chin'], { unique: false })
    dataStore.createIndex('english', ['eng'], { unique: false })

    //  store is like a table or collection
    const blobStore = db.createObjectStore('blobData', { keyPath: 'title' })
    //  Create indexes to query
    blobStore.createIndex('chinese', ['chinese'], { unique: false })
  }

  request.onsuccess = function () {
    console.log('Database opened successfully')

    const db = request.result

    db.onerror = e => {
      console.error('Error loading database')
      console.log(e)
    }
    //  transactions (used to create 'store') happen all at once - if one fails they
    // all fail  Example: removing data won't happen if it fails to store somewhere
    // else  Multibple transactins can be created to group actions that MUST pass or
    // fail all together
    const transaction = db.transaction('phraseData', 'readwrite')
    const store = transaction.objectStore('phraseData')

    // Add some data - extra data items can be added but can't be queried without
    // a query index
    const checkDatabase = store.count()
    checkDatabase.onsuccess = function () {
      if (checkDatabase.result < PHRASE_DATA.length) {
        PHRASE_DATA.forEach(async (phrase, i) => {
          //  Add to the phraseData store
          store.put(phrase)
          console.log(phrase)
        })
        console.log('Adding data', checkDatabase.result, PHRASE_DATA.length)
        setLoading(PHRASE_DATA.length)

        let count = 0
        PHRASE_DATA.forEach(async (phrase, i) => {
          //  Add to the phraseData store

          console.log(phrase)

          const clip = phrase.vocals[0]
          const title = clip.title
          const english = phrase.eng
          const phonetic = phrase.phon
          const chinese = phrase.chin

          console.log(`/getBlob/${title}`)
          //  Fetch the audio for storing in indexedDB
          setTimeout(() => {
          fetch(`/getBlob/${title}`, {
            method: 'POST',
          })
            .then(data => data.blob())
            .then(async blob => {
              count++
              setClipId(title)
              setPercent(((count / +PHRASE_DATA.length) * 100).toFixed(2))
              storeBlob(blob, title, english, phonetic, chinese)
              setProgBarWidth((count / +PHRASE_DATA.length) * 100)
              if ({ loading } && count === PHRASE_DATA.length) setLoading(false)
              if (i === PHRASE_DATA.length - 1) {
                transaction.oncomplete = function () {
                  db.close()
                }
              }
            })
            .catch(error => {
              if (typeof error.json === "function") {
                  error.json().then(jsonError => {
                      console.log("Json error from API");
                      console.log(jsonError);
                  }).catch(genericError => {
                      console.log("Generic error from API");
                      console.log(error.statusText);
                  });
              } else {
                  console.log("Fetch error");
                  console.log(error);
              }
          })     
          }, 200 * i);

        })
      } else {
        console.log(`Data is already there: ${checkDatabase.result} Items`)
        setLoading(false)
      }

      // transaction.oncomplete = function () {
      //   db.close()
      // }
    }
  }

  function storeBlob(blob, title, english, phonetic, chinese) {
 
    const blobObj = {
      blob: blob,
      title: title,
      english: english,
      phonetic: phonetic,
      chinese: chinese,
    }

    const indexedDB =
      window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB
    const request = indexedDB.open('learnChinese', versNum)

    request.onsuccess = function () {
      const db = request.result
      const transaction = db.transaction('blobData', 'readwrite')
      const store = transaction.objectStore('blobData')
      //  This check if blob exists is probably not necessary
      const idQuery = store.get(blobObj.chinese)
      idQuery.onsuccess = () => {
        const result = idQuery.result
        if (result === undefined) store.put(blobObj)
      }
      transaction.oncomplete = function () {
        db.close()
      }
    }
  }
}

// Query the blob table
export async function getBlob({ title, chinese, setCurrentBlobs }) {
  console.log({
    title: title,
    chinese: chinese,
  })
  const indexedDB =
    window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB
  const request = indexedDB.open('learnChinese', versNum)
  request.onsuccess = function () {
    const db = request.result
    const transaction = db.transaction('blobData', 'readwrite')
    const store = transaction.objectStore('blobData')
    if (title) {
      console.log('getting by title')
      const idQuery = store.get(title)
      idQuery.onsuccess = () => success([idQuery.result])
    } else if (chinese) {
      console.log('getting by character - ' + chinese)
      const chiIndex = store.index('chinese')
      const idQuery = chiIndex.getAll([chinese])
      //  Get index (query) reference(s)
      idQuery.onsuccess = () => success(idQuery.result)
    }

    function success(result) {
      console.log('Blob', result)
      setCurrentBlobs(result)
    }
    transaction.oncomplete = function () {
      db.close()
    }
  }
}


// Query the blob table
export async function returnBlob({ chinese }) {
  return new Promise((res, rej) => {
    const indexedDB =
      window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB
    const request = indexedDB.open('learnChinese', versNum)
    request.onsuccess = function () {
      const db = request.result
      const transaction = db.transaction('blobData', 'readwrite')
      const store = transaction.objectStore('blobData')
     if (chinese) {
        console.log('getting by character - ' + chinese)
        const chiIndex = store.index('chinese')
        const idQuery = chiIndex.getAll([chinese])
        //  Get index (query) reference(s)
        idQuery.onsuccess = () => success(idQuery.result)
      }

      function success(result) {
        console.log('Blob', result)
        // if (setBlobs) setBlobs(result)
        //  else
        res(result)
      }
      transaction.oncomplete = function () {
        db.close()
      }
    }
  })
}

// Query the index
export function getByIndex(index) {
  console.log('Get by index: ' + index)
  const indexedDB = window.indexedDB || window.webkitIndexedDB
  const request = indexedDB.open('learnChinese', versNum)
  request.onsuccess = function () {
    const db = request.result
    const transaction = db.transaction('phraseData', 'readwrite')
    const store = transaction.objectStore('phraseData')
    const idQuery = store.get(index)
    idQuery.onsuccess = function () {
      console.log(
        '%cGet by index',
        'text-decoration: underline;font-weight: 900;font-size: 15px',
        idQuery.result
      )
    }
    transaction.oncomplete = function () {
      db.close()
    }
  }
  request.onerror = e => {
    console.log('error')
    console.log(e)
  }
}

// Query the English Text
export function getByEnglish(text, setEnglish) {
  const indexedDB =
    window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB
  const request = indexedDB.open('learnChinese', versNum)
  request.onsuccess = function () {
    const db = request.result
    const transaction = db.transaction('phraseData', 'readwrite')
    const store = transaction.objectStore('phraseData')
    //  Get index (query) reference(s)
    const engIndex = store.index('english')
    const idQuery = engIndex.get([text])
    idQuery.onsuccess = function () {
      setEnglish(idQuery.result)
    }
    transaction.oncomplete = function () {
      db.close()
    }
  }
}

// Query the Chinese chars
export function getByCharacters(chars) {
  const indexedDB =
    window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB
  const request = indexedDB.open('learnChinese', versNum)
  request.onsuccess = function () {
    const db = request.result
    const transaction = db.transaction('phraseData', 'readwrite')
    const store = transaction.objectStore('phraseData')
    //  Get index (query) reference(s)
    const charIndex = store.index('chinese')
    const idQuery = charIndex.get([chars])
    idQuery.onsuccess = function () {
      console.log(
        '%cGet by character(s)',
        'text-decoration: underline;font-weight: 900;font-size: 15px',
        idQuery.result
      )
    }
    transaction.oncomplete = function () {
      db.close()
    }
  }
}
